<div class="w-full itm-page-layout">
    @if (toolbar() != undefined && toolbar().yPosition=='top') {
        <div>
            <itm-toolbar [toolbarType]="toolbar()?.toolbarType" [buttons]="buttons()"
                [overflowMode]="'Popup'"
                [breadcrumb]="breadcrumb()"></itm-toolbar>
        </div>
        }
<!-- <br> -->

    <div class="w-full">
        <ejs-tab id="element" #tab
            (selected)="clickTabs($event)" 
            (selecting)="select($event)" >
            <e-tabitems>

                <e-tabitem *ngIf="!isMobile()">
                    <ng-template #headerText>
                        <div> Action Required </div>
                     </ng-template>
                     <ng-template #content>
                        <div id="gridWrapper" class="gridWrapper" [style.height.px]="gridHeight">
                            <ejs-grid #gridActionRequired height='100%' [dataSource]='dsActionRequired' [loadingIndicator]='loadingIndicator'
                                [rowRenderingMode]="rowMode()"
                                [toolbar]='toolbarActionRequired' [allowGrouping]='true' [allowExcelExport]='true' [allowPdfExport]="true"
                                [allowReordering]="true" [allowResizing]="true" [allowPaging]='true' allowFiltering="true"
                                [pageSettings]='pageSettings' [selectionSettings]='selectionOptions' [allowSorting]="true"
                                showColumnChooser='true' gridLines='Both' width='auto' (dataBound)="onActionRequiredDataBound()"
                                (excelQueryCellInfo)='excelQueryCellInfo($event)' (queryCellInfo)='customiseCell($event)'
                                (actionFailure)="fail($event)" [filterSettings]="filterSettings" [searchSettings]='searchSettings' 
                                (rowDataBound)="rowDataBound($event)" (detailDataBound)='detailDataBound($event)'
                                (exportDetailDataBound)="exportDetailDataBound($event)" [detailTemplate]="detailTemplate"
                                [groupSettings]='groupOptions' (beforeDataBound)='beforeDataBound($event)' (actionBegin)="onListViewActionBegin($event)"
                                (rowSelected)="onRowSelected($event)" (rowDeselected)="onRowDeselected($event)" (recordClick)="onRecordClick($event)" [resizeSettings]="resizeSettings">

                                <ng-template #detailTemplate let-data>
                                    <div *ngIf="data.hasChild" class="pb-[4px] pt-[2px] child-grid">
                                        <!-- Nested Child Grid -->
                                        <div class='custom-grid'></div>
                                    </div>
                                        <div *ngIf="isMobile()" class="p-1 border rounded detail-container">
                                            <p class="p-1"><strong>Action Id:</strong> {{ data.action_Id }}</p>
                                            <p class="p-1"><strong>Created At:</strong> {{ formatByTimezone(data, 'occuredDateTime') }}</p>
                                            <p class="p-1"><strong>Branch Id:</strong> {{ data.branchId }}</p>
                                            <p class="p-1"><strong>Company:</strong> {{ data.companyName }}</p>
                                            <p class="p-1"><strong>Equipment No:</strong> {{ data.equipmentNo }}</p>
                                            <p class="p-1"><strong>Contract No:</strong> {{ data.contractNo }}</p>
                                        </div>
                                </ng-template>

                                <e-columns>
                                    <e-column field="id" headerText="ID" [visible]="false" isPrimaryKey="true" [showInColumnChooser]="false"></e-column>

                                    <e-column type='checkbox' allowFiltering='false' allowSorting='false' [width]='40' textAlign='Left' headerText="Select" 
                                    [visible]='true'></e-column>

                                    <e-column field='action_Id' headerText="Action Id" visible='true' [allowSorting]='true'
                                        type='string' textAlign='Left' [width]='100' *ngIf="!isMobile()"
                                        showInColumnChooser='false' [allowFiltering]='true'>
                                        <!-- <ng-template #template let-data>
                                            <a class="edit-name-link" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">{{data.action_Id}}</a>
                                        </ng-template> -->
                                    </e-column>

                                    <e-column field='occuredDateTime' [headerText]='occuredDateTimeText' visible='true'
                                        type='datetime' [textAlign]="textAlign()" [width]='150' [allowSorting]='true' [format]="{ type: 'dateTime', format: 'dd/MM/yyyy hh:mm:ss a' }"
                                        [allowFiltering]='true' *ngIf="!isMobile()">
                                        <ng-template #template let-data>
                                            {{ formatByTimezone(data, 'occuredDateTime') }}
                                        </ng-template>
                                    </e-column>

                                    <e-column field='branchId' headerText='Branch ID' visible='true' *ngIf="!isMobile()"
                                        type='number' textAlign='Left' [width]='100' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='companyName' headerText='Company' visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='200' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='subject' headerText='Subject' visible='true' class="subject-wrapper"
                                        type='string' textAlign='Left' [width]='200' [allowSorting]='true'
                                        [allowFiltering]='true'>
                                        <ng-template #template let-data>
                                            <div class="sub-wrapper">
                                                @if(isMobile()){
                                                <div class="text-content cursor-pointer" (click)="toggleChildGrid($event, data, gridActionRequired)">{{ data.subject }}</div>
                                                }
                                                @else {
                                                <div class="text-content">{{ data.subject }}</div>
                                                }

                                                @if(data.hasChild && !isMobile()){
                                                <a class="e-icons e-swimlane-row-collapse" href="javascript:void(0)" (click)="toggleChildGrid($event, data, gridActionRequired)">
                                                </a>
                                                }
                                                @else if (data.hasChild && isMobile()){
                                                <a class="e-icons e-swimlane-row-collapse" href="javascript:void(0)" (click)="toggleChildGrid($event, data, gridActionRequired)">
                                                </a>
                                                }
                                            </div>
                                        </ng-template>
                                    </e-column>
                                    
                                    <e-column field='equipmentNo' headerText='Equipment No' visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='150' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='contractNo' headerText="Contract No" visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='150' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    @if(!isMobile()){
                                    <e-column field='statusText' headerText='Status' visible='true'
                                        type='string' [textAlign]="textAlign()" [width]='100' [allowSorting]='true'
                                        [allowFiltering]='true'>
                                        <ng-template #template let-data>
                                            <a class="" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">
                                                <div class="status text-white rounded-[9999px] pt-[2px] pb-[3px] pl-[4px] pr-[4px] shadow-[0_0_8px_#fff]">{{data.statusText}}
                                                </div>
                                            </a>
                                        </ng-template>
                                        <!-- <ng-template #template let-data>
                                            <div class="status">
                                                {{data.statusText}}
                                            </div>
                                        </ng-template> -->
                                    </e-column>

                                    <!-- <e-column headerText='Action' visible='true'
                                        type='string' [textAlign]="textAlign()" [width]='80' [allowSorting]='false'
                                        [allowFiltering]='false'>
                                        <ng-template #template let-data>
                                            @if(data.actionTypeId == ActionType.Alert){
                                                <button ejs-button (click)="onClickActionContextMenu($event, data)" class="action-button">...</button>
                                            }
                                        </ng-template>
                                    </e-column> -->
                                    }

                                    @if(isMobile()){
                                    <e-column field='statusText' headerText="Status" visible='true' [allowSorting]='true'
                                        type='string' textAlign='Left' [width]='100'
                                        showInColumnChooser='false' [allowFiltering]='true'>
                                        <ng-template #template let-data>
                                            <!-- <a class="edit-name-link" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">{{data.statusText}}</a> -->
                                            <a class="" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">
                                                <div class="status text-white rounded-[9999px] pt-[2px] pb-[3px] pl-[4px] pr-[4px] shadow-[0_0_8px_#fff]">{{data.statusText}}
                                                </div>
                                            </a>
                                        </ng-template>
                                    </e-column>
                                    }
                                    
                                </e-columns>
                            </ejs-grid>
                        </div>
                    </ng-template>
                </e-tabitem>

                <e-tabitem *ngIf="false">
                    <ng-template #headerText>
                        <div> Actioned </div>
                     </ng-template>
                     <ng-template #content>
                        <div id="gridWrapper" class="gridWrapper" [style.height.px]="gridHeight">
                            <ejs-grid #gridActionedView height='100%' [dataSource]='dsActioned' [loadingIndicator]='loadingIndicator'
                                [rowRenderingMode]="rowMode()"
                                [toolbar]='toolbarOptions' [allowGrouping]='true' [allowExcelExport]='true' [allowPdfExport]="true"
                                [allowReordering]="true" [allowResizing]="true" [allowPaging]='true' allowFiltering="true"
                                [pageSettings]='pageSettings' [selectionSettings]='selectionOptions' [allowSorting]="true"
                                showColumnChooser='true' gridLines='Both' width='auto' (dataBound)="onActionedDataBound()"
                                (excelQueryCellInfo)='excelQueryCellInfo($event)' (queryCellInfo)='customiseCell($event)'
                                (actionFailure)="fail($event)" [filterSettings]="filterSettings" [searchSettings]='searchSettings' 
                                (rowDataBound)="rowDataBound($event)" (detailDataBound)='detailDataBound($event)'
                                (exportDetailDataBound)="exportDetailDataBound($event)" [detailTemplate]="detailTemplate"
                                [groupSettings]='groupOptions' (beforeDataBound)='beforeDataBound($event)' (actionBegin)="onListViewActionBegin($event)"
                                (rowSelected)="onRowSelected($event)" (rowDeselected)="onRowDeselected($event)" (recordClick)="onRecordClick($event)" [resizeSettings]="resizeSettings">

                                <ng-template #detailTemplate let-data>
                                    <div *ngIf="data.hasChild" class="pb-[4px] pt-[2px] child-grid">
                                        <!-- Nested Child Grid -->
                                        <div class='custom-grid'></div>
                                    </div>
                                        <div *ngIf="isMobile()" class="p-1 border rounded detail-container">
                                            <p class="p-1"><strong>Action Id:</strong> {{ data.action_Id }}</p>
                                            <p class="p-1"><strong>Created At:</strong> {{ formatByTimezone(data, 'occuredDateTime') }}</p>
                                            <p class="p-1"><strong>Branch Id:</strong> {{ data.branchId }}</p>
                                            <p class="p-1"><strong>Company:</strong> {{ data.companyName }}</p>
                                            <p class="p-1"><strong>Equipment No:</strong> {{ data.equipmentNo }}</p>
                                            <p class="p-1"><strong>Contract No:</strong> {{ data.contractNo }}</p>
                                        </div>
                                </ng-template>

                                <e-columns>
                                    <e-column field="id" headerText="ID" [visible]="false" isPrimaryKey="true" [showInColumnChooser]="false"></e-column>

                                    <e-column type='checkbox' allowFiltering='false' allowSorting='false' [width]='40' textAlign='Left' headerText="Select" 
                                    [visible]='true'></e-column>

                                    <e-column field='action_Id' headerText="Action Id" visible='true' [allowSorting]='true'
                                        type='string' textAlign='Left' [width]='100' *ngIf="!isMobile()"
                                        showInColumnChooser='false' [allowFiltering]='true'>
                                        <!-- <ng-template #template let-data>
                                            <a class="edit-name-link" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">{{data.action_Id}}</a>
                                        </ng-template> -->
                                    </e-column>

                                    <e-column field='occuredDateTime' [headerText]='occuredDateTimeText' visible='true'
                                        type='datetime' [textAlign]="textAlign()" [width]='150' [allowSorting]='true' [format]="{ type: 'dateTime', format: 'dd/MM/yyyy hh:mm a' }"
                                        [allowFiltering]='true' *ngIf="!isMobile()">
                                        <ng-template #template let-data>
                                            {{ formatByTimezone(data, 'occuredDateTime') }}
                                        </ng-template>
                                    </e-column>

                                    <e-column field='branchId' headerText='Branch ID' visible='true' *ngIf="!isMobile()"
                                        type='number' textAlign='Left' [width]='100' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='companyName' headerText='Company' visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='200' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='subject' headerText='Subject' visible='true' class="subject-wrapper"
                                        type='string' textAlign='Left' [width]='200' [allowSorting]='true'
                                        [allowFiltering]='true'>
                                        <ng-template #template let-data>
                                            <div class="sub-wrapper">
                                                @if(isMobile()){
                                                <div class="text-content cursor-pointer" (click)="toggleChildGrid($event, data, gridActionedView)">{{ data.subject }}</div>
                                                }
                                                @else {
                                                <div class="text-content">{{ data.subject }}</div>
                                                }

                                                @if(data.hasChild && !isMobile()){
                                                <a class="e-icons e-swimlane-row-collapse" href="javascript:void(0)" (click)="toggleChildGrid($event, data, gridActionedView)">
                                                </a>
                                                }
                                                @else if (data.hasChild && isMobile()){
                                                <a class="e-icons e-swimlane-row-collapse" href="javascript:void(0)" (click)="toggleChildGrid($event, data, gridActionedView)">
                                                </a>
                                                }
                                            </div>
                                        </ng-template>
                                    </e-column>
                                    
                                    <e-column field='equipmentNo' headerText='Equipment No' visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='150' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='contractNo' headerText="Contract No" visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='150' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    @if(!isMobile()){
                                    <e-column field='statusText' headerText='Status' visible='true'
                                        type='string' [textAlign]="textAlign()" [width]='100' [allowSorting]='true'
                                        [allowFiltering]='true'>
                                        <ng-template #template let-data>                                            
                                            <a class="" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)"><div class="status text-white rounded-[9999px] pt-[2px] pb-[3px] pl-[4px] pr-[4px] shadow-[0_0_8px_#fff]" >
                                                    {{data.statusText}}</div></a>
                                        </ng-template>
                                        <!-- <ng-template #template let-data>
                                            <div class="status">
                                                {{data.statusText}}
                                            </div>
                                        </ng-template> -->
                                    </e-column>

                                    <!-- <e-column headerText='Action' visible='true'
                                        type='string' [textAlign]="textAlign()" [width]='80' [allowSorting]='false'
                                        [allowFiltering]='false'>
                                        <ng-template #template let-data>
                                            @if(data.actionTypeId == ActionType.Alert){
                                                <button ejs-button (click)="onClickActionContextMenu($event, data)" class="action-button">...</button>
                                            }
                                        </ng-template>
                                    </e-column> -->
                                    }

                                    @if(isMobile()){
                                    <e-column field='statusText' headerText="Status" visible='true' [allowSorting]='true'
                                        type='string' textAlign='Left' [width]='100'
                                        showInColumnChooser='false' [allowFiltering]='true'>
                                        <ng-template #template let-data>
                                            <a class="edit-name-link" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">{{data.statusText}}</a>
                                        </ng-template>
                                    </e-column>
                                    }
                                    
                                </e-columns>
                            </ejs-grid>
                        </div>
                    </ng-template>
                </e-tabitem>

                <e-tabitem>
                    <ng-template #headerText>
                        <div> All Actions </div>
                     </ng-template>
                     <ng-template #content>
                        
                        <div id="gridWrapper" class="gridWrapper" [style.height.px]="gridHeight">
                            <div class="archived-control">
                                <button ejs-button cssClass="e-flat" [content]="toggleBtnText" (click)="onArchivedChange($event)"></button>
                            </div>

                            <ejs-grid #grid height='100%' [dataSource]='urlAdapterData' [loadingIndicator]='loadingIndicator' [cssClass]="'list-view-grid'"
                                [rowRenderingMode]="rowMode()"
                                [toolbar]='toolbarOptions' [allowGrouping]='true' [allowExcelExport]='true' [allowPdfExport]="true"
                                [allowReordering]="true" [allowResizing]="true" [allowPaging]='true' allowFiltering="true"
                                [pageSettings]='pageSettings' [selectionSettings]='selectionOptions' [allowSorting]="true"
                                showColumnChooser='true' gridLines='Both' width='auto' (dataBound)="onListViewDataBound()"
                                (excelQueryCellInfo)='excelQueryCellInfo($event)' (queryCellInfo)='customiseCell($event)'
                                (actionFailure)="fail($event)" [filterSettings]="filterSettings" [searchSettings]='searchSettings' 
                                (rowDataBound)="rowDataBound($event)" (detailDataBound)='detailDataBound($event)'
                                (exportDetailDataBound)="exportDetailDataBound($event)" [detailTemplate]="detailTemplate"
                                [groupSettings]='groupOptions' (beforeDataBound)='beforeDataBound($event)' (actionBegin)="onListViewActionBegin($event)"
                                (rowSelected)="onRowSelected($event)" (rowDeselected)="onRowDeselected($event)" (recordClick)="onRecordClick($event)" [resizeSettings]="resizeSettings">

                                <ng-template #detailTemplate let-data>
                                    <div *ngIf="data.hasChild" class="pb-[4px] pt-[2px] child-grid">
                                        <!-- Nested Child Grid -->
                                        <div class='custom-grid'></div>
                                    </div>
                                        <div *ngIf="isMobile()" class="p-1 border rounded detail-container">
                                            <p class="p-1"><strong>Action Id:</strong> {{ data.action_Id }}</p>
                                            <p class="p-1"><strong>Created At:</strong> {{ formatByTimezone(data, 'occuredDateTime') }}</p>
                                            <p class="p-1"><strong>Branch Id:</strong> {{ data.branchId }}</p>
                                            <p class="p-1"><strong>Company:</strong> {{ data.companyName }}</p>
                                            <p class="p-1"><strong>Equipment No:</strong> {{ data.equipmentNo }}</p>
                                            <p class="p-1"><strong>Contract No:</strong> {{ data.contractNo }}</p>
                                        </div>
                                </ng-template>

                                <e-columns>
                                    <e-column field="id" headerText="ID" [visible]="false" isPrimaryKey="true" [showInColumnChooser]="false"></e-column>

                                    <e-column type='checkbox' allowFiltering='false' allowSorting='false' [width]='40' textAlign='Left' headerText="Select" 
                                    [visible]='true'></e-column>

                                    <e-column field='action_Id' headerText="Action Id" visible='true' [allowSorting]='true'
                                        type='string' textAlign='Left' [width]='100' *ngIf="!isMobile()"
                                        showInColumnChooser='false' [allowFiltering]='true'>
                                        <!-- <ng-template #template let-data>
                                            <a class="edit-name-link" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">{{data.action_Id}}</a>
                                        </ng-template> -->
                                    </e-column>

                                    <e-column field='occuredDateTime' [headerText]='occuredDateTimeText' visible='true'
                                        type='datetime' [textAlign]="textAlign()" [width]='150' [allowSorting]='true' [format]="{ type: 'dateTime', format: 'dd/MM/yyyy hh:mm a' }"
                                        [allowFiltering]='true' *ngIf="!isMobile()">
                                        <ng-template #template let-data>
                                            {{ formatByTimezone(data, 'occuredDateTime') }}
                                        </ng-template>
                                    </e-column>

                                    <e-column field='branchId' headerText='Branch ID' visible='true' *ngIf="!isMobile()"
                                        type='number' textAlign='Left' [width]='100' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='companyName' headerText='Company' visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='200' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='subject' headerText='Subject' visible='true' class="subject-wrapper"
                                        type='string' textAlign='Left' [allowSorting]='true'
                                        [allowFiltering]='true'>
                                        <ng-template #template let-data>
                                            <div class="sub-wrapper">
                                                @if(isMobile()){
                                                <div class="text-content cursor-pointer" (click)="toggleChildGrid($event, data, grid)">{{ data.subject }}</div>
                                                }
                                                @else {
                                                <div class="text-content">{{ data.subject }}</div>
                                                }

                                                @if(data.hasChild && !isMobile()){
                                                <a class="e-icons e-swimlane-row-collapse" href="javascript:void(0)" (click)="toggleChildGrid($event, data, grid)">
                                                </a>
                                                }
                                                @else if (data.hasChild && isMobile()){
                                                <a class="e-icons e-swimlane-row-collapse" href="javascript:void(0)" (click)="toggleChildGrid($event, data, grid)">
                                                </a>
                                                }
                                                <!-- @if(data.actionTypeId == ActionType.Alert){
                                                    <div>
                                                        <button ejs-button (click)="onClickActionContextMenu($event, data)" 
                                                        class="flex h-[26px] border-transparent bg-inherit text-[24px] font-bold rotate-[90deg] leading-[0]">...</button>
                                                    </div>
                                                } -->
                                            </div>
                                        </ng-template>
                                    </e-column>
                                    
                                    <e-column field='equipmentNo' headerText='Equipment No' visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='150' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='contractNo' headerText="Contract No" visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='150' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    @if(!isMobile()){
                                    <e-column field='statusText' headerText='Status' visible='true'
                                        type='string' [textAlign]="textAlign()" [width]='120' [allowSorting]='true'
                                        [allowFiltering]='true'>
                                        <ng-template #template let-data>                                            
                                            <a class="" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">
                                                <div class="status text-white rounded-[9999px] pt-[2px] pb-[3px] pl-[4px] pr-[4px] shadow-[0_0_8px_#fff]">{{data.statusText}}</div></a>
                                        </ng-template>
                                    </e-column>

                                    <e-column headerText='Action' visible='true'
                                        type='string' [textAlign]="textAlign()" [width]='80' [allowSorting]='false'
                                        [allowFiltering]='false'>
                                        <ng-template #template let-data>
                                            @if(data.actionTypeId == ActionType.Alert){
                                                <button ejs-button (click)="onClickActionContextMenu($event, data)" class="action-button">...</button>
                                            }
                                        </ng-template>
                                    </e-column>
                                    }

                                    @if(isMobile()){
                                    <e-column field='statusText' headerText="Status" visible='true' [allowSorting]='true'
                                        type='string' [textAlign]='textAlign()' [width]='120'
                                        showInColumnChooser='false' [allowFiltering]='true'>
                                        <ng-template #template let-data>
                                            <!-- <a class="edit-name-link" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">{{data.statusText}}</a> -->
                                            <a class="" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">
                                                <div class="status text-white rounded-[9999px] pt-[2px] pb-[3px] pl-[4px] pr-[4px] shadow-[0_0_8px_#fff]">{{data.statusText}}</div>
                                            </a>
                                        </ng-template>
                                    </e-column>
                                    }
                                    
                                </e-columns>
                            </ejs-grid>
                        </div>

                     </ng-template>
                </e-tabitem>

                <e-tabitem *ngIf="false">
                    <ng-template #headerText>
                        <div> Kanban View </div>
                     </ng-template>
                     <ng-template #content>

                        <div class="kanbanWrapper" class="kanbanWrapper" [style.height.px]="kanbanHeight" style="overflow: auto">
                            <action-centre-kanban #kanban></action-centre-kanban>
                        </div>

                     </ng-template>
                </e-tabitem>

                <!-- [cssClass]="'right-tab'"  -->
                <e-tabitem>
                    <ng-template #headerText>
                        <div> Archived </div>
                     </ng-template>
                     <ng-template #content>

                        <div id="gridWrapper" class="gridWrapper" [style.height.px]="gridHeight">
                            <div class="archived-control">
                                <button ejs-button cssClass="e-flat" [content]="toggleBtnText" (click)="onArchivedChange($event)"></button>
                            </div>

                            <ejs-grid #gridArchived height='100%' [dataSource]='urlArchiveAdapterData' [loadingIndicator]='loadingIndicator'
                                [toolbar]='toolbarOptions' [allowGrouping]='true' [allowExcelExport]='true' [allowPdfExport]="true"
                                [allowReordering]="true" [allowResizing]="true" [allowPaging]='true' allowFiltering="true"
                                [pageSettings]='pageSettings' [selectionSettings]='selectionOptions' [allowSorting]="true"
                                showColumnChooser='true' gridLines='Both' width='auto' (dataBound)="onListViewDataBound()"
                                (excelQueryCellInfo)='excelQueryCellInfo($event)' (queryCellInfo)='customiseCell($event)'
                                (actionFailure)="fail($event)" [filterSettings]="filterSettings" [searchSettings]='searchSettings' 
                                [groupSettings]='groupOptions' (beforeDataBound)='beforeDataBound($event)' (actionBegin)="onArchivedViewActionBegin($event)"
                                (rowSelected)="onRowSelected($event)" (rowDeselected)="onRowDeselected($event)" (recordClick)="onRecordClick($event)" [resizeSettings]="resizeSettings">
                                <e-columns>

                                    <!-- <e-column field='id' headerText='Id' isPrimaryKey="true" [visible]='false'></e-column> -->

                                    <e-column type='checkbox' allowFiltering='false' allowSorting='false' [width]='40' textAlign='Left' [visible]='false'></e-column>

                                    <e-column field='action_Id' headerText="Action Id" visible='true' [allowSorting]='true'
                                        type='string' textAlign='Left' [width]='100' *ngIf="!isMobile()"
                                        showInColumnChooser='false' [allowFiltering]='true'>
                                        <!-- <ng-template #template let-data>
                                            <a class="edit-name-link" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">{{data.action_Id}}</a>
                                        </ng-template> -->
                                    </e-column>

                                    <e-column field='occuredDateTime' [headerText]='occuredDateTimeText' visible='true'
                                        type='datetime' [textAlign]="textAlign()" [width]='150' [allowSorting]='true' [format]="{ type: 'dateTime', format: 'dd/MM/yyyy hh:mm a' }"
                                        [allowFiltering]='true' *ngIf="!isMobile()">
                                        <ng-template #template let-data>
                                            {{ formatByTimezone(data, 'occuredDateTime') }}
                                        </ng-template>
                                    </e-column>

                                    <e-column field='branchId' headerText='Branch ID' visible='true' *ngIf="!isMobile()"
                                        type='number' textAlign='Left' [width]='100' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='companyName' headerText='Company' visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='200' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='subject' headerText='Subject' visible='true'
                                        type='string' textAlign='Left' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='equipmentNo' headerText='Equipment No' visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='150' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    <e-column field='contractNo' headerText="Contract No" visible='true' *ngIf="!isMobile()"
                                        type='string' textAlign='Left' [width]='150' [allowSorting]='true'
                                        [allowFiltering]='true'></e-column>
                                    
                                    @if(!isMobile()){
                                    <e-column field='statusText' headerText='Status' visible='true'
                                        type='string' [textAlign]="textAlign()" [width]='100' [allowSorting]='true'
                                        [allowFiltering]='true'>
                                        <ng-template #template let-data>                                            
                                            <a class="" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">
                                                <div class="status text-white rounded-[9999px] pt-[2px] pb-[3px] pl-[4px] pr-[4px] shadow-[0_0_8px_#fff]">{{data.statusText}}</div>
                                            </a>
                                        </ng-template>
                                    </e-column>
                                    }

                                    @if(isMobile()){
                                    <e-column field='statusText' headerText="Status" visible='true' [allowSorting]='true'
                                        type='string' [textAlign]='textAlign()' [width]='120'
                                        showInColumnChooser='false' [allowFiltering]='true'>
                                        <ng-template #template let-data>
                                            <!-- <a class="edit-name-link" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">{{data.statusText}}</a> -->
                                            <a class="" title="Open slide out page" href="javascript:void(0)"
                                                (click)="onClickAction(data.id)">
                                                <div class="status text-white rounded-[9999px] pt-[2px] pb-[3px] pl-[4px] pr-[4px] shadow-[0_0_8px_#fff]">{{data.statusText}}</div>
                                            </a>
                                        </ng-template>
                                    </e-column>
                                    }
                                    
                                </e-columns>
                            </ejs-grid>
                        </div>

                     </ng-template>
                </e-tabitem>
            </e-tabitems>
        </ejs-tab>

        <ejs-contextmenu [cssClass]="'action-context-menu'"
            #actionContextMenu
            [items]="actionMenuItemsData"
            (select)="onSelectActionContextMenu($event)">
        </ejs-contextmenu>
    </div>

    <div class="sidebar-container">
        <fuse-drawer
            class="w-screen min-w-screen sm:w-100 sm:min-w-160 z-999"
            fixed
            [mode]="'over'"
            [name]="'settingsDrawer'"
            [position]="'right'"
            (openedChanged)="drawerOpen($event)"
            #actionCentreDetailsSidebar>
            <div class="container w-full">
                <sidebar-manager #sidebarManager [actionData]="selectedAction()" [openingAudit]="openingAudit()"
                    (firePopupCloseEvent)="closeClick()">                    
                </sidebar-manager>
            </div>
        </fuse-drawer>
    </div>
</div>